
<f-dialog
    v-model       = "value"
    :show-header  = "true"
    :full-screen  = "false"
    :hide-actions = "false"
    :width        = "500"
    :show-save    = "enableUpload"
    :title        = "$t('inb.upload.typeSelect.title')"
    :store-label  = "$t('inb.upload.typeSelect.confirm')"
    @store        = "onConfirm"
    @cancel       = "onCancel"
>
    <template v-slot:content>
        <div class="mt-2">
            <div class="lm-border pa-3 mt-3">
                <v-row dense>
                    <v-col>
                        {{ $t('inb.upload.typeSelect.hint', [fileNames.length]) }}
                    </v-col>
                </v-row>
                <v-row dense v-if="fileNames.length">
                    <v-col>
                        <ul class="file-list">
                            <li v-for="(name, index) in visibleFileNames" :key="index">
                                {{ name }}
                            </li>
                        </ul>
                        <a v-if="hiddenCount > 0" @click="expanded = true">
                            {{ $t('inb.upload.typeSelect.showMore', [hiddenCount]) }}
                        </a>
                        <a v-else-if="expanded && fileNames.length > collapsedCount" @click="expanded = false">
                            {{ $t('inb.upload.typeSelect.showLess') }}
                        </a>
                    </v-col>
                </v-row>
            </div>
            <div class="lm-border pa-3 mt-3">
                <inb-message-types
                    v-model = "selectedType"
                    :label  = "$t('inb.upload.typeSelect.label')"
                />
            </div>
        </div>
    </template>
</f-dialog>
